import { BookOutlined, GiftOutlined } from '@ant-design/icons';
import { Image } from 'antd';
import React, { useEffect, useState } from 'react';
import { PRODUCT_TYPE } from '../../../../../../common/constants';
import { getPrimaryToyImage } from '../../../../ultraPlanUtils';

const ToyThumbnail = ({ toy, size = 72, preview = true }) => {
  const imageUrl = getPrimaryToyImage(toy);
  const [hasError, setHasError] = useState(false);

  useEffect(() => setHasError(false), [imageUrl]);

  if (!imageUrl || hasError) {
    const Icon =
      toy?.type === PRODUCT_TYPE?.BOOK?.value ? BookOutlined : GiftOutlined;
    return (
      <div
        className="toy-thumbnail toy-thumbnail-placeholder"
        style={{ width: size, height: size }}
      >
        <Icon />
      </div>
    );
  }

  return (
    <div className="toy-thumbnail-root" style={{ width: size, height: size }}>
      <Image
        className="toy-thumbnail"
        width={size}
        height={size}
        src={imageUrl}
        alt={toy?.name}
        preview={preview ? { mask: 'View' } : false}
        onError={() => setHasError(true)}
      />
    </div>
  );
};

export default ToyThumbnail;
